import {
  Contractor,
  ContractorActive,
  Home,
  HomeActive,
  Requests,
  RequestsActive,
} from "@/assets/icons";
import {
  InboxIcon,
  InboxIconActive,
} from "@/components/side-navigation/inbox-icons";
import { BasicRoutePath } from "@/constants";
import { NavigationConfigItem } from "@/components/side-navigation/types";

export const navigationConfig: NavigationConfigItem[] = [
  {
    iconElement: Home,
    iconElementActive: HomeActive,
    path: BasicRoutePath.Home,
    title: "Home",
  },
  {
    iconElement: InboxIcon,
    iconElementActive: InboxIconActive,
    path: BasicRoutePath.Approvals,
    title: "Inbox",
  },
  {
    iconElement: Requests,
    iconElementActive: RequestsActive,
    path: BasicRoutePath.Requests,
    title: "Requests",
  },
  {
    iconElement: Contractor,
    iconElementActive: ContractorActive,
    path: BasicRoutePath.ContractorProfile,
    title: "Contractor Profile",
  },
];
